import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=332dde66&scoped=true&"
import script from "./pager.vue?vue&type=script&lang=ts&"
export * from "./pager.vue?vue&type=script&lang=ts&"
import style0 from "./pager.vue?vue&type=style&index=0&id=332dde66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332dde66",
  null
  
)

export default component.exports